import React, { useState, useEffect } from "react";

const SingleSlideCarousel = ({ slidess, interval = 3000 }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const totalSlides = slidess.length;

  // Automatic scrolling
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % totalSlides);
    }, interval);
    return () => clearInterval(timer); // Cleanup the interval on unmount
  }, [interval, totalSlides]);

  // Navigate manually
  const nextSlide = () => setCurrentIndex((prevIndex) => (prevIndex + 1) % totalSlides);
  const prevSlide = () => setCurrentIndex((prevIndex) => (prevIndex - 1 + totalSlides) % totalSlides);

  return (
    <div className="carousel">
      <button className="carousel-button prev" onClick={prevSlide} aria-label="prev slide">
        &lt;
      </button>
      <div className="carousel-container">
        <div className="carousel-track" style={{ transform: `translateX(-${currentIndex * 100}%)` }}>
          {slidess.map((slide, index) => (
            <div
              key={index}
              className="carousel-item"
              style={{ width: "100%" }}
            >
              <a href={slide.link} target="_blank" rel="noopener noreferrer">
                <img src={slide.image} alt={slide.caption} />
              </a>
              <p>{slide.caption}</p>
            </div>
          ))}
        </div>
      </div>
      <button className="carousel-button next" onClick={nextSlide} aria-label="next slide">
        &gt;
      </button>
    </div>
  );
};

export default SingleSlideCarousel;